document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  const section = document.querySelector(".agilitas-scroll-hero");
  if (!section) return;
  const words = gsap.utils.toArray(
    ".agilitas-title .word"
  );
  const media = section.querySelector(
    ".agilitas-media-wrapper"
  );
  const intro = section.querySelector(
    ".agilitas-intro"
  );
  const story = section.querySelector(
    ".agilitas-story"
  );

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "bottom bottom",
      scrub: true
    }
  });

  words.forEach((word) => {
    tl.to(
      word,
      {
        color: "#111",
        duration: 0.25
      }
    );
  });

  tl.to(
    intro,
    {
      y: 300,
      opacity: 0,
      duration: 1
    },
    "+=0.2"
  );

  if(window.innerWidth > 768){
    tl.to(
      media,
      {
        width:"100vw",
        height:"100vh",
        top:"50%",
        left:"50%",
        x:0,
        y:0,
        borderRadius:0,
        duration:1.5,
        onStart:()=>{
          media.classList.add("zoomed");
        }
      },
      "<"
    );
  }
  else{
    tl.to(
      media,
      {
        width:"100vw",
        height:"100vh",
        top:"50%",
        left:"50%",
        x:0,
        y:0,
        borderRadius:0,
        duration:1.5,
        onStart:()=>{
          media.classList.add("zoomed");
        }
      },
      "<"
    );
  }

  tl.to(
    story,
    {
      opacity:1,
      y:0,
      duration:1
    },
    "-=0.4"
  );
});

// video popup script


document.addEventListener("DOMContentLoaded", () => {

  const openBtn = document.getElementById("video_popup_button");

  const popup = document.getElementById("agilitas-video-popup");

  if (!openBtn || !popup) return;

  const overlay = popup.querySelector(".agilitas-video-popup__overlay");

  const closeBtn = popup.querySelector(".agilitas-video-popup__close");

  const video = document.getElementById("agilitas-popup-video");

  const playBtn = document.getElementById("popup-play-pause");

  const muteBtn = document.getElementById("popup-mute-toggle");


  // Open

  openBtn.addEventListener("click", () => {

    popup.classList.add("active");

    document.body.style.overflow = "hidden";

    video.muted = true;

    video.play();

    playBtn.querySelector(".icon-play").style.display = "none";
    playBtn.querySelector(".icon-pause").style.display = "block";

    muteBtn.querySelector(".icon-mute").style.display = "block";
    muteBtn.querySelector(".icon-unmute").style.display = "none";

  });


  // Close

  function closePopup(){

    popup.classList.remove("active");

    document.body.style.overflow = "";

    video.pause();

    video.currentTime = 0;

  }

  closeBtn.addEventListener("click", closePopup);

  overlay.addEventListener("click", closePopup);


  // ESC close

  document.addEventListener("keydown",(e)=>{

    if(e.key==="Escape"){

      closePopup();

    }

  });


  // Play Pause

playBtn.addEventListener("click",()=>{

  const playIcon = playBtn.querySelector(".icon-play");
  const pauseIcon = playBtn.querySelector(".icon-pause");

  if(video.paused){

    video.play();

    playIcon.style.display = "none";
    pauseIcon.style.display = "block";

  }else{

    video.pause();

    playIcon.style.display = "block";
    pauseIcon.style.display = "none";

  }

});


  // Mute Unmute

  muteBtn.addEventListener("click",()=>{

  const muteIcon = muteBtn.querySelector(".icon-mute");
  const unmuteIcon = muteBtn.querySelector(".icon-unmute");

  video.muted = !video.muted;

  if(video.muted){

    muteIcon.style.display = "block";
    unmuteIcon.style.display = "none";

  }else{

    muteIcon.style.display = "none";
    unmuteIcon.style.display = "block";

  }

});

});